export const SCRATCHCARD_DISPLAY_MODES = {
  BACKSIDE: 'backside',
  FRONT_SCRATCHED: 'front-scratched',
  FRONT_UNSCRATCHED: 'front-unscratched',
} as const

export type ScratchcardDisplayMode = ObjectValues<typeof SCRATCHCARD_DISPLAY_MODES>
